export default __webpack_public_path__ + "4f74d788dfa76e8aaf1551ed07f2bc37.jpg";